import React from "react";
import ParticleBackground from "./ParticleBackground";

export default function Mission() {

    const missionData = [
        {
          title: "Mission",
          text: "We strive to unlock every learner's full potential through exceptional online tutoring, a dynamic learning environment and an unwavering commitment to excellence.",
          color: "#8e44ad",
          icon: "🎯"
        },
        {
          title: "Foster Academic Excellence",
          text: "We are committed to helping students reach their full academic potential by offering tailored educational programs and personalized support.",
          color: "#2980b9",
          icon: "📘"
        },
        {
          title: "Remove Geographic Barriers",
          text: "We believe that education should know no boundaries. Our platform enables students from around the world to access world-class education.",
          color: "#27ae60",
          icon: "🌍"
        },
        {
          title: "Promote Inclusivity",
          text: "We strive to create a diverse and inclusive learning environment, welcoming students from all walks of life.",
          color: "#e74c3c",
          icon: "🤝"
        },
      ];
      
      const visionData = [
        {
          title: "Vision",
          text: "To be the global leader in online education, empowering students to realize their full potential and achieve academic excellence regardless of their geographic location or socio-economic background.",
          color: "#e67e22",
          icon: "🌟"
        },
        {
          title: "Enhance Learning Flexibility",
          text: "We provide flexible learning options, accommodating various curricula and schedules to meet the diverse needs of our students.",
          color: "#9b59b6",
          icon: "📅"
        },
        {
          title: "Empower Educators",
          text: "We support our educators with the tools and resources they need to be effective, innovative, and inspiring educators.",
          color: "#8e44ad",
          icon: "👩‍🏫"
        },
        {
          title: "Drive Affordability",
          text: "We make high-quality education affordable and accessible to students and families, ensuring that cost is not a barrier to academic success.",
          color: "#c0392b",
          icon: "💰"
        },
      ];

      return (
      
      <section className="mission-vision--section relative overflow-hidden" id="Mission">
      {/* Background */}
      <ParticleBackground/>

      {/* Section Heading */}
      <div className="relative z-10 text-center">
        <h2 className="section-heading"><u>Mission, Vision & Values</u></h2><br></br><br></br><br></br>
        <p className="mt-6 text-lg">
          <h3><span className="highlight-red">AlphaBeta4Success, </span>
          <span className="highlight-black">We are an organisation that is passionate about making a difference to young people in our communities.</span></h3>
        </p>
      </div><br></br><br></br><br></br>

      {/* Mission & Vision Cards */}
      <div className="mission-vision--container relative z-10 mt-16">
        <div className="mission--list">
          {missionData.map((item, index) => (
            <div className="mission--card" key={index} style={{ borderLeft: `5px solid ${item.color}` }}>
              <div className="icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>

        <div className="vision--list">
          {visionData.map((item, index) => (
            <div className="vision--card" key={index} style={{ borderLeft: `5px solid ${item.color}` }}>
              <div className="icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}